export const USER_CONFIRM_FETCH_REQUEST = 'user-confirm-fetch-request';
export const USER_CONFIRM_FETCH_SUCCESS = 'user-confirm-fetch-success';
export const USER_CONFIRM_FETCH_FAILURE = 'user-confirm-fetch-failure';